import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { CredentialService } from "./credential.service";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs/Observable";
import { environment } from "environments/environment";
import { inflate } from "zlib";

const errorCodes = [400, 401, 403, 404];

@Injectable()
export class PrestaSubassemblyService {
  constructor(
    private authService: AuthenticationService,
    private credentialService: CredentialService,
    private store: Store<any>
  ) {}

  private invokePrestaSubassembly(payload: any): Observable<any> {
    return new Observable(observer => {
      this.credentialService.lambda.invoke({
        FunctionName: environment.batchFunction,
        Payload: JSON.stringify(payload)
      }, (err, data) => {
        if (err) {
          if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
            this.authService.refreshCredentials();
          }
          observer.error(err.stack);
        } else {
          const output = typeof data.Payload === 'string'
            ? JSON.parse(data.Payload)
            : data.Payload;
          if(output.gzip){
            const options = {
              windowBits: 15
            };
            inflate(new Buffer(output.body,'base64'), options, (err, data) => {
              if (err) {
                observer.error(err.stack);
              } else {
                const unzippedOutput = Object.assign({}, output, {
                  body: data.toString()
                });
                observer.next(unzippedOutput);
              }
            });
          } else {
            observer.next(output);
          }
        }
      });
    });
  }

  // private invokePrestaSubassemblyMutation(payload: any): Observable<any> {
  //   return new Observable(observer => {
  //     this.credentialService.lambda.invoke({
  //       FunctionName: environment.batchFunction,
  //       Payload: JSON.stringify(payload)
  //     }, (err, data) => {
  //       if (err) {
  //         if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
  //           this.authService.refreshCredentials();
  //         }
  //         observer.error(err.stack);
  //       } else {
  //         observer.next(data);
  //       }
  //     });
  //   });
  // }

  private invokePrestaSubassemblyMutation(payload: any): void {
    this.credentialService.lambda.invoke({
      FunctionName: environment.batchFunction,
      Payload: JSON.stringify(payload)
    }, (err, data) => {
      if (err) {
        if (errorCodes.find(code => code === err.statusCode) && localStorage.getItem('currentUser')) {
          this.authService.refreshCredentials();
        }
      }
    });
  }

  getConfigById(id: string): Observable<any> {
    const query = `{
      getConfigById(id: "${id}") {
        id
        subassembly
        presta
        isActive
        createdAt
        updatedAt
      }
    }`;

    return this.invokePrestaSubassembly({ query });
  }

  getConfigBySubassembly(subassembly: string): Observable<any> {
    const query = `{
      getConfigBySubassembly(subassembly: "${subassembly}") {
        id
        subassembly
        presta
        isActive
        createdAt
        updatedAt
      }
    }`;

    return this.invokePrestaSubassembly({ query });
  }

  getConfigByPrestaAndSubassembly(presta: string, subassembly: string): Observable<any> {
    const query = `{
      getConfigByPrestaAndSubassembly(presta: "${presta}", subassembly: "${subassembly}") {
        id
        subassembly
        presta
        isActive
        createdAt
        updatedAt
      }
    }`;

    return this.invokePrestaSubassembly({ query });
  }

  getAll(): Observable<any> {
    const query = `{
      listPrestaSubassemblyConfigs {
        id
        subassembly
        presta
        isActive
        createdAt
        updatedAt
      }
    }`;

    return this.invokePrestaSubassembly({ query });
  }

  createPrestaSubassemblyConfig(config: any): void {
    const variables = { prestaSubassemblyConfig: config };
    const query = `mutation ($prestaSubassemblyConfig: PrestaSubassemblyConfigCreateInput!) {
      createPrestaSubassemblyConfig(prestaSubassemblyConfig: $prestaSubassemblyConfig) {
        id
        subassembly
        presta
        isActive
      }
    }`;

    this.invokePrestaSubassemblyMutation({ query, variables });
  }

  updatePrestaSubassemblyConfig(config: any): void {
    const variables = { prestaSubassemblyConfig: config };
    const query = `mutation ($prestaSubassemblyConfig: PrestaSubassemblyConfigInput!) {
      updatePrestaSubassemblyConfig(prestaSubassemblyConfig: $prestaSubassemblyConfig) {
        id
        subassembly
        presta
        isActive
      }
    }`;

    this.invokePrestaSubassemblyMutation({ query, variables });
  }

  deletePrestaSubassemblyConfig(id: string): void {
    const variables = { id };
    const query = `mutation ($id: String!) {
      deletePrestaSubassemblyConfig(id: $id) {
        id
      }
    }`;

    this.invokePrestaSubassemblyMutation({ query, variables });
  }
} 


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/services/presta-subassembly.service.ts